import * as React from "react"
import { Link } from "react-router-dom"
import { Col, Row } from "reactstrap"

import { Paper, IconButton, Picture } from "components"

import "./product.scss"

interface Product extends IconButton {
	text: string
	image: string
	link: string
	srcSet?: string
	webP?: string
}

const Product: React.FC<Product> = ({
	text,
	color,
	image,
	link,
	srcSet,
	webP,
}) => {
	return (
		<Paper className="product">
			<Row className="justify-content-center  text-center align-items-center">
				<Picture
					alt={text}
					src={image}
					srcSet={srcSet}
					className="product__image"
					webP={webP}
				/>
				<Col>
					<p>{text}</p>
					<Link to={link}>
						<IconButton color={color}>خرید</IconButton>
					</Link>
				</Col>
			</Row>
		</Paper>
	)
}

export default Product
